const API_URL = '/api/contact/';

export const sendContactMessage = async (formData) => {
  try {
    const payload = {
      name: formData.name,
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
    };

    console.log('Sending contact form data:', payload);

    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log('Success response:', data);
    return { success: true, data };
  } catch (error) {
    console.error('Error sending contact message:', error);
    return { success: false, error: error.message };
  }
};
